import { apiRequest } from '../api/client';
import { API_ENDPOINTS, withParams } from '../config/apis';

export type GoodsRepresentativeEvent = {
  eventId: number;
  title: string;
  imageUrl: string | null;
};

export type GoodsRepresentativeEventListResponse = {
  events: GoodsRepresentativeEvent[];
};

export type GoodsRepresentativeImageResponse = {
  imageUrl: string;
};

export type GoodsItem = {
  id: number;
  name: string;
  description: string | null;
  imageUrl: string;
};

export type GoodsListResponse = {
  goods: GoodsItem[];
};

export type GoodsCreateRequest = {
  name: string;
  description: string;
};

export const goodsRepresentativeService = {
  listEvents: () =>
    apiRequest<GoodsRepresentativeEventListResponse>(
      API_ENDPOINTS.goodsRepresentativeEventList
    ),

  create: (eventId: number, image: File) =>
    apiRequest<void, FormData>(
      withParams(API_ENDPOINTS.goodsRepresentativeCreate, { eventId }),
      { body: toImageFormData(image) }
    ),

  update: (eventId: number, image: File) =>
    apiRequest<GoodsRepresentativeImageResponse, FormData>(
      withParams(API_ENDPOINTS.goodsRepresentativeUpdate, { eventId }),
      { body: toImageFormData(image) }
    ),

  delete: (eventId: number) =>
    apiRequest<void>(
      withParams(API_ENDPOINTS.goodsRepresentativeDelete, { eventId })
    ),

  listGoods: (eventId: number) =>
    apiRequest<GoodsListResponse>(
      withParams(API_ENDPOINTS.goodsList, { eventId })
    ),

  createGoods: (eventId: number, request: GoodsCreateRequest, image: File) =>
    apiRequest<GoodsItem, FormData>(
      withParams(API_ENDPOINTS.goodsCreate, { eventId }),
      { body: toGoodsFormData(request, image) }
    ),

  deleteGoods: (eventId: number, goodsId: number) =>
    apiRequest<void>(
      withParams(API_ENDPOINTS.goodsDelete, { eventId, goodsId })
    ),
};

function toImageFormData(image: File) {
  const formData = new FormData();
  formData.append('image', image);
  return formData;
}

function toGoodsFormData(request: GoodsCreateRequest, image: File) {
  const formData = new FormData();
  formData.append(
    'goods',
    new Blob([JSON.stringify(request)], { type: 'application/json' })
  );
  formData.append('image', image);
  return formData;
}
